import React from "react";
import TopBar from "./components/TopBar";
import Footer from "./components/Footer";
import { Grid } from '@mui/material'
import Header from "./components/Header";
import { Outlet } from "react-router-dom";
import { useLocation } from "react-router-dom";
const DashBoardLayout = () => {
  const location = useLocation()
  return (
    <Grid container sx={{ height: "100vh" }}>
      <Grid item xs={12} >
        <Header />
      </Grid>
      <Grid item xs={12}>
        <TopBar />
      </Grid>
      <Grid item xs={12} sx={{ height: "calc(100vh - 21vh)", overflowY: location.pathname == '/app/Analytics' ? "scroll" : location.pathname == '/app/Reports' ? "scroll" : "hidden" }}>
        <Outlet />
      </Grid>
      <Grid item xs={12}>
        <Footer />
      </Grid>
    </Grid>
  );
};

export default DashBoardLayout;
